import * as React from 'react';
import { GiftVoucherCard } from './GiftVoucherCard';
import { ReactNode } from 'react';
import { GiftVoucherDto, GiftVouchersProps } from './GiftVouchersUtils';
import { isNullOrUndefined } from '../../../../../Util/TypeGuards';

export const GiftVouchers = ({
	reload,
	listOfGiftCertificates,
	claimedVoucherId,
}: GiftVouchersProps & { claimedVoucherId?: string }) => {
	return (
		// eslint-disable-next-line max-len
		<div
			className={`gift-voucher-list__container ${(listOfGiftCertificates?.count ?? 0) > 4 ? 'pagination-applied' : ''}`}
		>
			{giftVouchersInner(reload, listOfGiftCertificates?.giftVouchers, claimedVoucherId)}
		</div>
	);
};

export const giftVouchersInner = (refresh: () => void, giftVouchers?: GiftVoucherDto[], claimedVoucherId?: string) => {
	const vouchers: ReactNode[] = [];
	if (isNullOrUndefined(giftVouchers)) {
		return <></>;
	}
	if (giftVouchers?.length > 0) {
		giftVouchers.forEach((x: GiftVoucherDto) => {
			vouchers.push(
				<GiftVoucherCard
					key={x.id}
					giftVoucher={x}
					refresh={refresh}
					justClaimed={x.id === claimedVoucherId}
				/>,
			);
		});

		return vouchers;
	}
	return (
		<div className="no-vouchers__container">
			<p>No credits to display</p>
		</div>
	);
};
